module.exports = __webpack_public_path__ + "static/media/toy-logo.63a9cf1e.svg";